<template>
    <div class="review--sent">
        <div class="panel" primary noradius boxed>
            <div class="review--sent--title">
                <div v-if="review_state == 'accepted'">
                    Grazie della tua richiesta di pubblicazione!
                </div>
                <div v-if="review_state == 'declined'">
                    Grazie della tua richiesta di modifica!
                </div>
                <div v-if="review_state == 'rejected'">
                    Grazie del tuo commento!
                </div>
            </div>
            <div class="review--sent--subtitle">
                <b-row>
                    <b-col>
                        <div v-if="review_state == 'accepted'">
                            <p>
                                Dacci il tempo di bloccare e riservare i servizi da te richiesti. Appena finito pubblicheremo il viaggio sul nostro sito
                                Agenzia Viaggi by Vivamod e ti invieremo un'email con le istruzioni per procedere all'acquisto utilizzando il tuo credito welfare.
                            </p>
                            <p>
                                <strong>
                                    Il prodotto pubblicato avrà una scadenza che, in caso di prenotazione di voli, potrà essere a stretto giro, per cui ti
                                    consigliamo di controllare frequentemente la tua posta elettronica e procedere con tempestività.
                                </strong>
                            </p>
                        </div>
                        <div v-if="review_state == 'declined'">
                            <p>
                                I nostri consulenti di viaggio si occuperanno il prima possibile di realizzare una nuova proposta in base alle tue richieste.
                            </p>
                            <p>
                                <strong>
                                    Riceverai un'email con la nuova proposta. Ti consigliamo di controllare frequentemente la tua posta elettronica.
                                </strong>
                            </p>
                        </div>
                        <div v-if="review_state == 'rejected'">
                            <p>
                                Il nostro servizio viene migliorato e innovato ogni giorno.
                            </p>
                            <p>
                                Torna a trovarci o seguici su <u><a :href="facebook" target="_blank">Facebook</a></u>
                                o <u><a :href="instagram" target="_blank">Instagram</a></u> per non perderti nessuna novità.
                            </p>
                        </div>
                        <p>
                            <strong>
                                Per qualsiasi informazione scrivici all'indirizzo
                                <a :href="'mailto:'+email_support">{{email_support}}</a> o contattaci in webchat.
                            </strong>
                        </p>
                        <br><br>
                        <b-button variant="light" @click="() => { this.$router.push({ name: 'homepage' }) }">Torna alla home</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        name: 'review-sent',
        components: {
        },
        props:
        {
            opened: {
                type: Boolean,
                default: false,
            },
            completed: {
                type: Boolean,
                default: false,
            },
            review_state: {
                type: String,
                default: ''
            }
        },
        created()
        {
        },
        data() {
            return {
                email_support: Vue.prototype.$config.site.emailSupport,
                facebook: Vue.prototype.$config.site.facebook,
                instagram: Vue.prototype.$config.site.instagram,
            }
        },
        computed: {
            loading: {
                get() {
                    return this.$store.state.loading
                },
            },
        },
        mounted() {
        },
        methods:{
        },
    }
</script>

<style lang="scss">
    .review--sent
    {
        @extend .review--block !optional;
        margin-bottom:4rem;
        text-align: left;
        overflow: hidden;
        &--title
        {
            font-size: 28px;
            font-weight: 600;
            padding:$grid-gutter-width/4 0;
            border-radius: $border-radius;
        }
        &--subtitle
        {
            font-size: 14px;
            font-weight: 400;
            padding:$grid-gutter-width/2 0 $grid-gutter-width/4 0;
            margin-top:0;
        }
        .btn-light
        {
            color:$text !important;
        }
    }
</style>